export default __webpack_public_path__ + "media/images/images/portrait/large/avatar-l-1-3fcdc4dd383fdac4267a7746ff6790f5.png";